import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, StoreState } from "../../redux/store";
import { getPublicProfileByUsername } from "../../redux/users/usersSlice";

const useFetchPublicUserInfos = (username: string | null | undefined) => {
  const dispatch = useDispatch<AppDispatch>();
  const { item, loading, error } = useSelector((state: StoreState) => state.users);

  useEffect(() => {
    if (username) {
      dispatch(getPublicProfileByUsername(username));
    }
  }, [dispatch, username]);

  return { loading, error, publicUser: item };
};

export default useFetchPublicUserInfos;
